import { connect } from 'react-redux';

import {
  deleteUserSubmittedQuestion,
  editSubmitQuestion,
  getUserSubmittedQuestions,
  setDeleteStatusMessage,
  setSelectedQuestion,
  setUserQuestionsMessage,
  submitNewQuestion,
} from '../../actions/submitAQuestionActions';
import { getUser } from '../User/userSelectors';
import {
  getDeleteStatusMessageSelector,
  getIsUserQuestionsLoading,
  getSelectedQuestionSelector,
  getStatusMessage,
  getUserSubmittedQuestionsSelector,
} from './submitAQuestionSelectors';
import SubmitAQuestionView from './SubmitAQuestionView';

const mapStateToProps = (state) => ({
  userSubmittedQuestions: getUserSubmittedQuestionsSelector(state),
  isUserQuestionsLoading: getIsUserQuestionsLoading(state),
  statusMessage: getStatusMessage(state),
  user: getUser(state),
  deleteStatusMessage: getDeleteStatusMessageSelector(state),
  selectedQuestion: getSelectedQuestionSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  submitNewQuestion: (question) => {
    dispatch(submitNewQuestion(question));
  },
  setUserQuestionsMessage: (message) => {
    dispatch(setUserQuestionsMessage(message));
  },
  getUserSubmittedQuestions: () => {
    dispatch(getUserSubmittedQuestions());
  },
  deleteUserSubmittedQuestion: (questionId, timestamp) => {
    dispatch(deleteUserSubmittedQuestion(questionId, timestamp));
  },
  setDeleteStatusMessage: (message) => {
    dispatch(setDeleteStatusMessage(message));
  },
  editSubmitQuestion: (question, questionId, timestamp) => {
    dispatch(editSubmitQuestion(question, questionId, timestamp));
  },
  setSelectedQuestion: (question) => {
    dispatch(setSelectedQuestion(question));
  },
});

const SubmitAQuestionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubmitAQuestionView);

export default SubmitAQuestionContainer;
